import { Config } from '.';

const config: Config = {
    API_URL: 'https://api.api-tool.ktn.madeatsilverchip.com',
};

export default config;
